import { render } from "./HorizontalHeader.vue?vue&type=template&id=665eb147"
import script from "./HorizontalHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__